import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { initSmoothScroll } from './utils/smoothScroll';
import Header from './components/Header';
import Home from './pages/Home';
import Apply from './pages/Apply';
import './App.css';

function App() {
  useEffect(() => {
    const lenis = initSmoothScroll();
    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Apply />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
